import {
  SectionBenefitsBanner,
  SectionBenefitsBannerProps,
} from '@sbercloud/uikit-product-site-section';
import { useLayoutType } from 'src/hooks/useLayoutType';

type StatisticsBannerProps = {
  title?: string;
  image: string;
  items: {
    value: string;
    description: string;
  }[];
  notes?: string[];
};

export function StatisticsBanner({
  title,
  image,
  items,
  notes,
}: StatisticsBannerProps) {
  const layoutType = useLayoutType();

  return (
    <SectionBenefitsBanner
      title={title}
      items={items as SectionBenefitsBannerProps['items']}
      backgroundImage={image}
      layoutType={layoutType}
      description={notes}
    />
  );
}
